import React, { useEffect } from "react"

const BelowArticleThumbnails = () => {
  useEffect(() => {
    window._taboola = window._taboola || []
    window._taboola.push({
      mode: "alternating-thumbnails-a",
      container: "taboola-below-article-thumbnails",
      placement: "Below Article Thumbnails",
      target_type: "mix",
    })
  }, [])
  return <div id="taboola-below-article-thumbnails"></div>
}
export default BelowArticleThumbnails
